import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { NumberMixin, Spinner } from '@kwixeo/interface-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { BButton, BCol, BFormGroup, BFormRow, BRow } from 'bootstrap-vue'
import { KForm } from '@kwixeo/form-vue'
import { AxiosResponse } from 'axios'

@Component({
  computed: {
    ...mapGetters('user', ['can']),
    ...mapState('catalog', ['stockLocations'])
  },
  methods: {
    ...mapActions('catalog', ['loadStockLocations'])
  },
  components: {
    BFormRow,
    Spinner,
    BButton, BRow, BCol, BFormGroup,
    KForm
  }
})
export default class StockByLocations extends Mixins(NumberMixin) {
  loadStockLocations!: () => void
  stockLocations!: KwixeoCatalog.StockLocations
  can!: (key: string, level: number) => boolean

  @Prop({ required: true }) product!: KwixeoCatalog.Product
  @Prop({ default: null }) variation!: KwixeoCatalog.ProductVariation

  private loading = false
  private editMode = false
  private stocks: KwixeoCatalog.ProductStockLocations = []

  async mounted (): Promise<void> {
    this.loading = true
    await this.loadStockLocations()
    this.watchProduct()
    this.watchVariation()
    this.loading = false
  }

  get formAction (): string {
    if (this.variation) {
      return '/catalog/product/' + this.product.id + '/variation/' + this.variation.id + '/stock-location'
    }
    return '/catalog/product/' + this.product.id + '/stock-location'
  }

  get unitBuyPrice (): number {
    return this.number(this.product.unit_buy_price_ht)
  }

  @Watch('product', { deep: true })
  private watchProduct(): void {
    if (this.variation) {
      return
    }

    this.stocks = []
    this.stockLocations.forEach(location => {
      const value = this.product.stock_locations?.find(val => val.stock_location_id === location.id)
      this.stocks.push(
        value ? JSON.parse(JSON.stringify(value)) : {
        stock_location_id: location.id,
        stock_location: location,
        stock_theoretical_quantity: 0,
        stock_quantity: 0,
        total_stock_theoretical_ht: 0,
        total_stock_ht: 0
      } as KwixeoCatalog.ProductStockLocation)
    })
  }

  @Watch('variation', { deep: true })
  private watchVariation(): void {
    if (!this.variation) {
      return
    }

    this.stocks = []
    this.stockLocations.forEach(location => {
      const value = this.variation.stock_locations?.find(val => val.stock_location_id === location.id)
      this.stocks.push(
        value ? JSON.parse(JSON.stringify(value)) : {
          stock_location_id: location.id,
          stock_location: location,
          stock_theoretical_quantity: 0,
          stock_quantity: 0,
          total_stock_theoretical_ht: 0,
          total_stock_ht: 0
        } as KwixeoCatalog.ProductStockLocation)
    })
  }

  private submitComplete (response: AxiosResponse): void {
    this.$emit('input', response.data)
    this.editMode = false
  }
}
